<template>
  <div class="password_bg_style">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="modify_password_style">
      <div class="password_layout_style">
        <van-form>
          <van-field
            v-model="newPassword"
            type="password"
            label="新密码"
            placeholder="输入新密码"
          />
          <van-field
            v-model="newPasswordAgain"
            type="password"
            label="密码确认"
            placeholder="再次输入新密码"
          />
        </van-form>
      </div>
      <div style="margin: 47px 0">
        <van-button
          round
          block
          type="danger"
          native-type="submit"
          @click="modify_password_click"
          >完成</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return { newPassword: null, newPasswordAgain: null };
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
    modify_password_click() {
      if (this.newPassword == null || this.newPassword == "") {
        Toast.fail("请输入新密码");
        return;
      }
      if (this.newPasswordAgain == null || this.newPasswordAgain == "") {
        Toast.fail("请再次输入新密码");
        return;
      }
      if (this.newPassword != this.newPasswordAgain) {
        Toast.fail("密码不一致");
        return;
      }
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .post(
          "/modifyPassword",
          {
            userId,
            newPassword: this.newPassword,
            newPasswordAgain: this.newPasswordAgain,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$router.push({
              path: "/menu",
            });
            Toast.success("修改成功");
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-field__label {
  line-height: 40px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  color: #202f3b !important;
}
::v-deep .van-field__value {
  line-height: 40px !important;
}
.password_bg_style {
  background: #f5f6f8;
}
.modify_password_style {
  padding: 21px 15px 0 21px;
}
.password_layout_style {
  background: #fff;
}
</style>